import { useEffect } from 'react';

import { XMarkIcon } from '@/resources';
import { ModalLayoutType } from '@/types';

export const ModalLayout = ({ children, isOpen, onClose }: ModalLayoutType) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    }
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [isOpen]);

  if (!isOpen) {
    return null;
  }

  const handleOverlayClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.target === e.currentTarget) {
      handleClose();
    }
  };

  const handleClose = () => {
    onClose();
  };

  return (
    <div
      className={`${
        isOpen
          ? 'modal-backdrop-color fixed inset-0 z-50 flex items-center justify-center backdrop-blur-[1px]'
          : 'hidden'
      } size-full max-h-full overflow-y-auto overflow-x-hidden p-4`}
      onClick={handleOverlayClick}>
      <div
        className='filter-pop-up-shadow relative max-h-full w-full max-w-[25rem] rounded-2xl bg-white'
        onClick={(e) => e.stopPropagation()}>
        <div className='flex justify-end p-4'>
          <XMarkIcon className='size-3 cursor-pointer text-base' onClick={handleClose} />
        </div>
        <div className='flex w-full flex-1 justify-center'>{children}</div>
      </div>
    </div>
  );
};
